<script lang="ts">
    import {  Badge, Button, Image } from "sveltestrap";
    import { MyPage,  } from "../../../utils/Constant/Constant";
    import data from "../../../Data/SocialApp/SocialApp.json"
    let imgPath:string = "/assets/images/user"
</script>
<div class="socialprofile filter-cards-view">
    <div class="media">
        <Image fluid class="img-50 m-r-20 rounded-circle" src="{imgPath}/1.jpg" alt="" />
        <div class="media-body">
            <h6 class="font-primary f-w-600">{MyPage}</h6>
            {#each data.commentsdata as profileItem}
                <span class="d-block">
                    <span>
                        <i class={profileItem.icon}> </i>
                        <span class="px-2">{profileItem.name}<Badge pill color={profileItem.color} class="ms-2">{profileItem.number}</Badge></span>
                    </span>
                </span>
            {/each}
        </div>
    </div>
    <div class="social-btngroup d-flex">
        <Button color="primary" class="text-center" >Likes</Button>
        <Button color="light" class="text-center ms-2" >View</Button>
    </div>
    <div class="likes-profile text-center">
        <h5> <span> <i class="fa fa-heart font-danger"></i> 884</span></h5>
    </div>
    <div class="text-center">35 New Likes This Week</div>
    <div class="customers text-center social-group">
        <ul>
            {#each data.imagedata as profileItem}
                <li class="d-inline-block">
                    <Image class="img-40 rounded-circle" src="{imgPath}/{profileItem.img}" alt=""  />
                </li>
            {/each}
        </ul>
    </div>
</div>